<modal class="modal-window password-recovery" [width]="500" [style.height]="'auto'"  (closeOut)="closeModal()">
  <modal-header>
    <span>{{ strings.passwordExpirationPolicyTitle }}</span>
  </modal-header>

  <modal-body>
    <ti-set-new-password
      [needOldPassword]="true"
      [modalUseMode]="true"
      #setNewPassCmp
      (passwordUpdated)="closeModal()"
    ></ti-set-new-password>
  </modal-body>

  <modal-actions>
    <button kendoButton fillMode="solid" themeColor="tertiary" (click)="closeModal()">{{ miscStrings.cancel }}</button>
    <button kendoButton [primary]="true" (click)="setNewPassCmp?.setNewPassword()">
      {{ strings.change }}
    </button>
  </modal-actions>
</modal>
